module.exports = __webpack_public_path__ + "img/mobmenu.c7b63c81.svg";